/**
 * Bandeau défilant éditorial rappelant le contexte fondateur :
 *   Le Fil du Midi · 30 ans UNESCO · Canal du Midi · Riquet · 1666
 *
 * Utilisé en tête des pages fortes de récit (Riquet, Parcours, Nous rejoindre)
 * pour ne jamais laisser oublier l'anniversaire UNESCO 1996 → 2026.
 */
export default function UnescoMarquee() {
  const words = [
    "Le Fil du Midi",
    "30 ans UNESCO",
    "Canal du Midi",
    "Riquet · 1666",
  ];
  // 8 répétitions -> assez pour couvrir large + boucle infinie fluide
  const loop = Array.from({ length: 8 }).flatMap(() => words);

  return (
    <section
      className="relative border-y border-fg/15 bg-fg text-bg overflow-hidden"
      data-testid="unesco-marquee"
      aria-label="Le Fil du Midi — 30 ans UNESCO — Canal du Midi — Riquet 1666"
    >
      <div className="relative py-3.5 md:py-4">
        {/* Fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-fg to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-fg to-transparent z-10" />

        <div className="marquee-track flex items-center gap-8 md:gap-14 whitespace-nowrap">
          {loop.map((w, i) => (
            <span key={i} className="shrink-0 flex items-center gap-8 md:gap-14">
              <span className="font-serif italic text-xl md:text-2xl lg:text-3xl text-bg/95 tracking-tight">
                {w}
              </span>
              <span className="text-cinabre text-2xl leading-none">·</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
